export default "__VITE_ASSET__DnofnRVQ__"